import assert from 'assert';
import React from 'react';

import MultiSelectColumnDropdown from 'data-frames/column-selector/MultiSelectColumnDropdown';
import {GetPipelineConfigSpecType} from 'pipelines/StepShapeUtils';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {ButtonSize} from 'ui-library/buttons/Button';

import {getDataFrameInfoOrEmptyInfo, useStepConfigEditorContext} from '../StepConfigEditorContext';

interface MultiSelectColumnReferenceProps {
  config: Array<string | null>;
  onChangeConfig: (config: Array<string>) => void;
  configShape: GetPipelineConfigSpecType<'array'>;
  dataTestAttrs?: DataTestAttrs;
  disabled?: boolean;
}

export default function MultiSelectColumnReferenceEditor({
  config,
  onChangeConfig,
  configShape,
  dataTestAttrs,
  disabled,
}: MultiSelectColumnReferenceProps): JSX.Element {
  const {dataFramesInfos} = useStepConfigEditorContext();
  assert(
    configShape.elementSpec.kind === 'columnReference',
    'Invalid config shape for MultiSelectColumnReferenceEditor.'
  );
  const {dataFrameSpec} = getDataFrameInfoOrEmptyInfo(dataFramesInfos, configShape.elementSpec.inputDataName);

  const selectedColumnSystemNames = config.filter((columnReference) => columnReference != null);
  return (
    <MultiSelectColumnDropdown
      dataFrameSpec={dataFrameSpec}
      dataTestAttrs={dataTestAttrs}
      onChange={onChangeConfig}
      selectedColumnSystemNames={selectedColumnSystemNames}
      validationOptions={configShape.elementSpec.validationOptions ?? undefined}
      buttonSize={ButtonSize.MEDIUM}
      noColumnSelectedText="Select columns"
      disabled={disabled}
    />
  );
}
